import { artworkCmd } from './apiClient';

/** One saved version of a file, as `artwork.doc.versions.list` answers it (W5-AR1). */
export interface FileVersion {
  readonly id: string;
  /** What somebody called it; null for one saved on its own, which shows its time. */
  readonly name: string | null;
  /** auto: every few minutes of edits; named: somebody named it; restore: the file just before a restore. */
  readonly kind: 'auto' | 'named' | 'restore';
  readonly createdAt: string;
  readonly author: { readonly id: string; readonly name: string | null; readonly avatarUrl: string | null } | null;
  readonly thumbnailUrl: string | null;
  /** Its picture is still being drawn: ask again in a few seconds. */
  readonly thumbnailPending: boolean;
}

export async function listVersions(documentId: string, limit = 50, before?: string): Promise<{ versions: FileVersion[]; more: boolean }> {
  return artworkCmd('artwork.doc.versions.list', { documentId, limit, before });
}

export async function saveVersion(documentId: string, name: string): Promise<FileVersion> {
  return artworkCmd('artwork.doc.versions.save', { documentId, name });
}

export async function renameVersion(documentId: string, versionId: string, name: string | null): Promise<FileVersion> {
  return artworkCmd('artwork.doc.versions.rename', { documentId, versionId, name });
}

/** Answers the version to restore to take this one back. */
export async function restoreVersion(documentId: string, versionId: string): Promise<{ restored: string; undo: string }> {
  return artworkCmd('artwork.doc.versions.restore', { documentId, versionId });
}

export async function copyVersion(documentId: string, versionId: string): Promise<{ id: string; name: string }> {
  return artworkCmd('artwork.doc.versions.copy', { documentId, versionId });
}
